module.exports = __webpack_public_path__ + "img/ring_img.af11f699.png";